// extracted by mini-css-extract-plugin
export default {"container":"Shared_container__iHJwE","gridRow":"Shared_gridRow__-7vUo","importantText":"Shared_importantText__S6fo+","errorText":"Shared_errorText__Nb2xq"};